export enum ModalType {
  Success = 'success',
  Warning = 'warning',
  Failure = 'failure',
  Info = 'info',
  Error = 'error',
  Question = 'question',
  Confirmation = 'confirmation',
  Notification = 'notification',
  Default = 'default'
}
